import * as React from 'react';
import styled from 'styled-components';
import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';
import { Translate } from 'react-localize-redux';
import Box from '@components/layout/box';
import { AnimatePresence } from 'framer-motion';
import CompletedIcon from '@components/basics/icons/achievements-icons/completed';
import UnselectedIcon from '@components/basics/icons/unselected';
import SimpleUser from '@common/types/user/simple-user';
import DistributeOwnershipRowCtrl from "../distribute-ownership-row";
import CounterFixedButton from '@components/actions/counter-fixed-button';
import { RemoveManagerOwnership } from '@webapp/store/ownership/action-creators';
import SimpleArtist from '@common/types/artist/simple-artist';
import { CallHistoryMethodAction } from 'connected-react-router';
interface OwnershipDistributionProps {
  className?: string;
  teamMembers: SimpleUser[];
  selectedmember?:SimpleUser;
  isTablet: boolean;
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  trackData: any;
  artist?: SimpleArtist;
  setTrackData: React.Dispatch<React.SetStateAction<any>>;
  removeManagerOwnership:(artistId: string,trackOwnership: any,merchOwnership: any,removeOwnership:string)=>RemoveManagerOwnership;
  goToDashboard: () => CallHistoryMethodAction;
  setCompleteDistribution:React.Dispatch<React.SetStateAction<boolean>>;
}
export const OwnershipDistribution: React.FC<OwnershipDistributionProps> = (props) => {
  const [selected, setSelected] = React.useState('equal');
  const [splitError,setSplitError] = React.useState(false);
  const [updatedTeamMembersDetails,setUpdatedTeamMemberDetails] = React.useState<any>([]);
  React.useEffect(()=>{
    let managerSplit = 0;
    if (props.activeStep===1){
      if(props.selectedmember && props.selectedmember.split){
        managerSplit = props.selectedmember.split.recordingOwnership 
      }
    } else {
      if(props.selectedmember && props.selectedmember.split){
        managerSplit = props.selectedmember.split.merchOwnership 
      }
    }
    let round = ((managerSplit) / (props.teamMembers.filter((members)=>props.selectedmember?members.id !== props.selectedmember.id:true).length));
    let updatedTeamMembers: any = []
    props.teamMembers.filter((members) => props.selectedmember?props.selectedmember.id===members.id:true).forEach((members)=>{
      updatedTeamMembers.push({ ...members, split: 0,removed:true })
    })
    props.teamMembers.filter((members)=>props.selectedmember?props.selectedmember.id !== members.id:true).forEach((members, index) => {
      if (index < props.teamMembers.filter((members)=>props.selectedmember?props.selectedmember.id !== members.id:true).length - 1) {
        updatedTeamMembers.push({ ...members, split: Number(round.toFixed(2)),removed:false })
      }
      else {
        updatedTeamMembers.push({
          ...members, removed:false,split: Number((managerSplit - updatedTeamMembers.reduce((a, b) => {
            return a + Number(b.split)
          }, 0)).toFixed(2))
        })
      }
    })
    setUpdatedTeamMemberDetails(updatedTeamMembers);
    setSelected("equal");
  },[props.activeStep, props.selectedmember, props.teamMembers])
  // const [originalSplit,setOriginalSplit] = React.useState();
  const updateSplit = (split:number,ownerId:string)=>{
    let newUpdatedTeamMemberSplit = updatedTeamMembersDetails.map((teamMember)=>{
      if(teamMember.pk===ownerId){
        teamMember.split=split;
      }
      return teamMember;
    })
    setUpdatedTeamMemberDetails(newUpdatedTeamMemberSplit);
  }
  const getManagerSplit = () => {
    return props.activeStep === 1 ? ( props.selectedmember?.split?.recordingOwnership || 0) : (props.selectedmember?.split?.merchOwnership || 0);
  }
  const handleNextStepClick = () =>{
    setSplitError(false);
    let managerSplit = getManagerSplit();
    debugger;
    if(selected==="custom" && (updatedTeamMembersDetails.reduce((memo,teamMember)=>memo+Number(teamMember.split),0) !== managerSplit)){
      setSplitError(true);
      return;
    }
    if(props.activeStep===2){
      if(props.selectedmember?.id && props.artist?.id){
        props.setCompleteDistribution(true)
        props.removeManagerOwnership(props.artist?.id,props.trackData?.distribution,updatedTeamMembersDetails,props.selectedmember.id)
      }
    }
    else{
      
      props.setTrackData({distributeType:selected,distribution:updatedTeamMembersDetails});
      props.setActiveStep(props.activeStep+1)
    }
  }
  const Terms = [
    {
      value: 'equal',
      label: 'Distribute equally between members',
    },
    {
      value: 'custom',
      label: 'Distribute Ownership (custom)',
    },
  ];
  const handleSelected = (value) => {
    setSelected(value);
  };
  return (
    <Box noBorderBottom>
      <Wrapper>
        <Typography className="mb-10" type="subheader" customFont="semi-bold" style={{fontSize:"18px"}}>
          {props.activeStep===1?"Master Recording Ownership":"Merch Ownership"}
        </Typography>
        {Terms.map((term, i) => (
          <OwnershipTermBox>
            <TermBox
              className={`term ${selected === term.value ? 'active' : ''} ${'no-border-bottom'}`}
              onClick={() => handleSelected(term.value)}
              key={`${term.value}-${i}`}
            >
              <Typography weight="700">
                {term.label}
                {/* <Translate id={term.label} /> */}
              </Typography>
              <AnimatePresence exitBeforeEnter>
                {selected === term.value ? (
                  <MotionOpacity>
                    <CompletedIcon className="icon" />
                  </MotionOpacity>
                ) : (
                  <MotionOpacity>
                    <UnselectedIcon className="icon" />
                  </MotionOpacity>
                )}
              </AnimatePresence>

            </TermBox>
            {(selected === "custom" && term.value === "custom") && (
              <AnimatePresence exitBeforeEnter>
                <div className={props.className}>
                  {updatedTeamMembersDetails.map((member) => {
                    return (
                      <React.Fragment
                        key={`distribute-ownership-split-editor-${member.id
                            ? member.id
                            : member.ownerId
                          }`}
                      >
                        <DistributeOwnershipRowCtrl className={props.className} owner={member} locked={false} updateCurrentSplit={(split,ownerId)=>updateSplit(split,ownerId)} managerSplit={getManagerSplit()} />
                      </React.Fragment>
                    )
                  })}
                  
                </div>
              </AnimatePresence>
            )}
          </OwnershipTermBox>
        ))}
        {splitError && (
          //
          <ErrorMessage>
            {`Distribution Ownership should be exact ${getManagerSplit()}`}
          </ErrorMessage>
        )}
      </Wrapper>
      <CounterFixedButton
        className={!props.isTablet ? '' : 'mt-30'}
        fixed={!props.isTablet}
        isValid={true}
        currentStep={props.activeStep}
        maxStep={2}
        disableLoader={
          true
        }
        isLoading={false}
        customLabel={
          <Translate id="ARTIST_PROFILE.SUBSCRIPTION.DISTRIBUTION.MENU.BTN.CONTINUE" />
        }
        onNext={() => handleNextStepClick()}
      />
    </Box>
  )
}
export default styled(OwnershipDistribution)`
  margin-bottom: 100px;
  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 0;
}`;
const Wrapper = styled.div`
  display: grid;
  grid-gap: 10px;
`;
const TermBox = styled.div`
  cursor: pointer;
  padding: 20px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  background-color: ${({ theme }) => theme.colors.differentBackground};
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  span {
    transition: color
      ${({ theme }) =>
    `${theme.transitions.duration} ${theme.transitions.type}`};
  }

  &.active {
    background-color: ${({ theme }) => theme.colors.primary};
    span {
      color: ${({ theme }) => theme.colors.differentBackground};
    }
  }

  &.no-border-bottom {
    border-radius: 4px 4px 0 0;
  }

  .icon {
    width: 32px;
    height: 32px;
  }
`;
const OwnershipTermBox = styled.div`
    position: relative;
    background-color: ${({ theme }) => theme.colors.differentBackground};
`;
const ErrorMessage = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.colors.error};
  font-size: 12px;
  font-family: 'Sen', sans-serif;
`;
